/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Imagecaption1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_imagecaption1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Imagecaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft’s sales sample illustrates its familiar spreadsheet workspace. Screenshot: ArtCraft.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_imagecaption1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Imagecaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 销售示例展示了熟悉的电子表格工作区。截图来源：ArtCraft。`)
};

/**
* | output |
* | --- |
* | "GridCraft’s sales sample illustrates its familiar spreadsheet workspace. Screenshot: ArtCraft." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Imagecaption1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_imagecaption1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Imagecaption1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Imagecaption1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_imagecaption1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_imagecaption1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_imagecaption1 as "gc.search_guides.gridcraft_vs_excel.imageCaption" }